import { AppClockComponent, containerConfiguration } from '@mews/framework';

import AppDateComponent from './components/appDateComponent';
import AppLocalizationComponent, { AppLocalizationComponentProps } from './components/appLocalizationComponent';

export interface BaseConfigurationProps {
    appClock: {
        context: Window;
        getServerNowUtc(): string;
    };
    appDate: {
        getCurrentEnterpriseIanaTimeZoneIdentifier(): string;
    };
    appLocalization: AppLocalizationComponentProps;
}

export default function baseContainerConfiguration({ appLocalization, appDate, appClock }: BaseConfigurationProps) {
    return containerConfiguration()
        .register(AppClockComponent, [], appClock)
        .register(AppDateComponent, [AppClockComponent], appDate)
        .register(AppLocalizationComponent, [], appLocalization);
}

declare global {
    interface CommanderContainer {
        /** @deprecated use appClockService from thunk or context */
        appClockComponent: ReturnType<typeof AppClockComponent>;
        /** @deprecated usage allowed only in legacy code: search, timeline and validation */
        appDateComponent: ReturnType<typeof AppDateComponent>;
        appLocalizationComponent: ReturnType<typeof AppLocalizationComponent>;
    }
}
